import { debounce } from 'lodash';

class BrixModuleSelectedPosts {
  static init(...parameters) {
    return new BrixModuleSelectedPosts(...parameters);
  }

  constructor(selector) {
    this.selector = selector;

    this.scrollWrapper = this.selector.querySelector('.scroll-wrapper');

    if (this.scrollWrapper) {
      this.selectedPostsWrapper = this.selector.querySelector('.posts');
      this.posts = this.selector.querySelectorAll('.post');
      this.firstPost = this.selectedPostsWrapper.querySelector('.post');
      this.earlierPostsButton = this.selector.querySelector('.scroll-button.-earlier');
      this.laterPostsButton = this.selector.querySelector('.scroll-button.-later');
      this.cardWidth = this.firstPost.clientWidth;


      this.updateAlignment();
      this.updateScrollWrapperHeight();

      if (this.earlierPostsButton) {
        this.earlierPostsButton.addEventListener('click', () => {
          this.selectedPostsWrapper.scrollBy({
            top: 0,
            left: window.innerWidth < 1024 ? -316 : -437,
            behavior: 'smooth',
          });
        });
      }

      if (this.earlierPostsButton) {
        this.laterPostsButton.addEventListener('click', () => {
          this.selectedPostsWrapper.scrollBy({
            top: 0,
            left: window.innerWidth < 1024 ? 316 : 437,
            behavior: 'smooth',
          });
        });
      }

      window.addEventListener('resize', debounce(() => {
        this.cardWidth = this.firstPost.clientWidth;
        this.updateAlignment();
        this.updateScrollWrapperHeight();
      }, 50));
    }
  }

  updateAlignment() {
    const gap = window.innerWidth < 1024 ? 16 : 40;

    if (this.selectedPostsWrapper.clientWidth <= this.scrollWrapper.clientWidth
      && ((this.posts.length * this.firstPost.clientWidth)
      + ((this.posts.length - 1) * gap))
      > this.selectedPostsWrapper.clientWidth) {
      this.selectedPostsWrapper.classList.add('-align-left');
    } else {
      this.selectedPostsWrapper.classList.remove('-align-left');
    }

    if (this.scrollWrapper.clientWidth === window.innerWidth) {
      this.selectedPostsWrapper.classList.add('-with-inner-padding');
    }
  }

  updateScrollWrapperHeight() {
    if (this.posts.length > 0) {
      this.scrollWrapper.style.height = '0';
      const highestPostElementHeight = Math.max(...[...this.posts].map(post => post.scrollHeight));
      if (highestPostElementHeight && typeof highestPostElementHeight === 'number') {
        this.scrollWrapper.style.height = `${highestPostElementHeight}px`;
      }
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-selected-posts', BrixModuleSelectedPosts.init);
}
